var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECF0F1"
    },
    cx: 256,
    cy: 256,
    r: 245.551
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EBD91"
    },
    points: "276.898,57.469 235.102,57.469 235.102,235.102 57.469,235.102 57.469,276.898  235.102,276.898 235.102,454.531 276.898,454.531 276.898,276.898 454.531,276.898 454.531,235.102 276.898,235.102 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M437.019,74.981C388.668,26.628,324.38,0,256,0S123.332,26.628,74.981,74.981S0,187.62,0,256 s26.628,132.668,74.981,181.019S187.62,512,256,512s132.668-26.628,181.019-74.981S512,324.38,512,256 S485.372,123.332,437.019,74.981z M256,491.102C126.365,491.102,20.898,385.635,20.898,256S126.365,20.898,256,20.898 S491.102,126.365,491.102,256S385.635,491.102,256,491.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M58.955,203.254c1.064,0.342,2.141,0.504,3.202,0.504c4.416,0,8.52-2.822,9.945-7.253 c9.431-29.326,25.315-55.298,47.211-77.193c21.895-21.896,47.867-37.779,77.193-47.211c5.494-1.767,8.515-7.653,6.748-13.147 c-1.767-5.494-7.655-8.515-13.147-6.748c-32.517,10.457-61.307,28.063-85.573,52.327c-24.265,24.265-41.87,53.056-52.327,85.573 C50.44,195.601,53.462,201.487,58.955,203.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M315.494,72.102c29.327,9.431,55.299,25.316,77.193,47.21 c21.895,21.896,37.779,47.868,47.212,77.193c1.424,4.43,5.528,7.253,9.945,7.253c1.06,0,2.138-0.163,3.201-0.505 c5.494-1.767,8.515-7.653,6.748-13.146c-10.457-32.516-28.063-61.307-52.327-85.572c-24.265-24.265-53.055-41.87-85.573-52.328 c-5.491-1.765-11.379,1.255-13.146,6.748C306.98,64.447,310.001,70.335,315.494,72.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M453.045,308.746c-5.49-1.767-11.379,1.255-13.146,6.748c-9.431,29.326-25.317,55.297-47.212,77.193 c-21.894,21.895-47.866,37.778-77.193,47.21c-5.494,1.767-8.515,7.653-6.748,13.147c1.424,4.43,5.527,7.253,9.945,7.253 c1.06,0,2.138-0.163,3.201-0.505c32.517-10.457,61.308-28.063,85.573-52.328c24.265-24.266,41.87-53.056,52.327-85.572 C461.561,316.399,458.539,310.513,453.045,308.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M196.506,439.898c-29.326-9.431-55.298-25.315-77.193-47.211 c-21.896-21.895-37.779-47.867-47.211-77.193c-1.767-5.494-7.653-8.514-13.147-6.748c-5.494,1.767-8.515,7.653-6.748,13.147 c10.457,32.517,28.063,61.307,52.327,85.573c24.265,24.265,53.056,41.87,85.573,52.327c1.064,0.342,2.141,0.505,3.202,0.505 c4.416,0,8.52-2.823,9.945-7.253C205.019,447.551,201.999,441.665,196.506,439.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M454.531,224.653H287.347V57.469c0-5.771-4.679-10.449-10.449-10.449h-41.796 c-5.771,0-10.449,4.678-10.449,10.449v167.184H57.469c-5.771,0-10.449,4.678-10.449,10.449v41.796 c0,5.771,4.678,10.449,10.449,10.449h167.184v167.184c0,5.771,4.678,10.449,10.449,10.449h41.796 c5.77,0,10.449-4.678,10.449-10.449V287.347h167.184c5.77,0,10.449-4.678,10.449-10.449v-41.796 C464.98,229.331,460.301,224.653,454.531,224.653z M444.082,266.449H276.898c-5.77,0-10.449,4.678-10.449,10.449v167.184h-20.898 V276.898c0-5.771-4.678-10.449-10.449-10.449H67.918v-20.898h167.184c5.771,0,10.449-4.678,10.449-10.449V67.918h20.898v167.184 c0,5.771,4.679,10.449,10.449,10.449h167.184V266.449z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralAdd);
export default __webpack_public_path__ + "static/media/general_add.c25022fe88fba699c69fd14215608446.svg";
export { ForwardRef as ReactComponent };